import { getDocs, query, where, collection, documentId } from "firebase/firestore";
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { db } from "../../firebase";
import { SpinnerCircular } from "spinners-react";
import './PoomDataChatroom.css';

const PoomDataChatroom = () => {
  const location = useLocation();
  const { chatRoomid } = location.state;
  const [dataDetailChatroom, setDataDetailChatroom] = useState();
  const personOneRef = useRef();
  const personTwoRef = useRef();

  // comment on line 10 & 11: poomProductid refers to the data that was passed down from the link component
  // we are retrieving that data here using the useLocation Hook that comes w/ React Router.
  // this data is needed for our query shown below.
  // comment on line 10: use useState hook to declare state variable. Initial state is an empty array, with setDataDetailChatroom updating the state accordingly.

  useEffect(() => {
    const getPoomDataChatroom = async () => {
      const userCol = query(
        collection(db, "chatrooms"),
        where("isPoom", "==", true),
        where(documentId(), "==", chatRoomid)
      );
      const poomProductDetail = await getDocs(userCol);
      try {
        setDataDetailChatroom(
          poomProductDetail.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
        );
      } catch (error) {
        console.log(error);
      }
    };
    getPoomDataChatroom();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (dataDetailChatroom !== undefined && dataDetailChatroom.length !== 0) {
    personOneRef.current = dataDetailChatroom[0].chatRoomPresent[0];
    personTwoRef.current = dataDetailChatroom[0].chatRoomPresent[1];
  }
  if (dataDetailChatroom === undefined) {
    return (
      <div className="grid h-screen place-items-center">
        <SpinnerCircular size="10%" color="rgb(255,199,0)" speed={180} />
      </div>
    );
  }
  if (dataDetailChatroom.length === 0) {
    return (
      <div className="max-w-[700px] mx-auto my-16 p-4">
        <h2 className="text-2xl font-bold py-2">
          No chatroom history of this post.
        </h2>
      </div>
    );
  }

  return (
    <div className="max-w-[700px] mx-auto my-16 p-4">
      <h2 className="text-2xl font-bold py-2">Chatroom History:</h2>
      {dataDetailChatroom.map((data) => {
        if ("status" in data) {
          return (
            <>
              <div className="pb-2">
                <b>Status:</b> {data.status}
              </div>
              <div>
                {data.messages.map((message) => {
                  console.log(message);
                  return (
                    <div
                      className={
                        message.message[0].user._id === personOneRef.current
                          ? "chatBoxOne"
                          : "chatBoxTwo"
                      }
                    >
                      <div className="">
                        <p className="text-black">
                          <b>{message.message[0].user.name}</b>:{' '}
                          <span>{message.message[0].text}</span>
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          );
        }
        return (
          <div>
            {data.messages.map((message) => {
              return (
                <div
                  className={
                    message.message[0].user._id === personOneRef.current
                      ? "chatBoxOne"
                      : "chatBoxTwo"
                  }
                >
                  <div className="">
                    <p className="text-black">
                      <b>{message.message[0].user.name}</b>:{" "}
                      <span>{message.message[0].text}</span>
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

export default PoomDataChatroom;
